import { Command as CommandPrimitive } from 'cmdk'

import { NoSearchResults } from '../ui/no-search-results'

export const Empty = ({ searchTerm }: { searchTerm: string }) => (
  <CommandPrimitive.Empty className='py-6 text-center'>
    <NoSearchResults failedQuery={searchTerm} />
  </CommandPrimitive.Empty>
)
